import { createSelector } from 'reselect';
import get from 'lodash/get';
import baseSelector from '@store/errorDiagnostics/base/selectors';
import { selectedCustomerIdSelector } from '@store/common/selectors';
import birdChartSelector from '@store/errorDiagnostics/birdChart/selectors';
import dimensionTablesSelector from '@store/errorDiagnostics/dimensionTables/selectors';
import viewerSessionsSelector from '@store/viewerSessions/selectors';
import { SCOPE } from './types';

const selector = state => get(state, SCOPE);

export default selector;

export const sharingSelector = createSelector(
  baseSelector,
  dimensionTablesSelector,
  birdChartSelector,
  viewerSessionsSelector,
  selectedCustomerIdSelector,
  (baseStore, dimensionTablesStore, birdChartStore, viewerSessionsStore, selectedCustomerId) => {
    const dashboard = 'Error Diagnostics';
    const { interval, currentErrorCode } = baseStore;

    const start = interval.from;
    const end = interval.to;
    const title = `${dashboard} ${start} ${end}`;
    const selectedMetrics = get(viewerSessionsStore, [currentErrorCode, 'selectedMetrics'], []);

    const {
      sliceFrom,
      sliceTo,
      zoomStart,
      zoomEnd,
      brushStart,
      brushEnd,
    } = birdChartStore;
    return {
      title,
      dashboard,
      start,
      end,
      state: {
        viewerSessionsTable: {
          selectedMetrics,
        },
        common: { selectedCustomerId },
        base: baseStore,
        dimensionTables: dimensionTablesStore.core,
        birdChart: {
          sliceFrom,
          sliceTo,
          zoomStart,
          zoomEnd,
          brushStart,
          brushEnd,
        },
      },
    };
  },
);

export const sharingResponseSelector = createSelector(
  selector,
  (store) => {
    const { response } = store;
    if (!response) {
      return null;
    }
    return JSON.parse(response.state);
  },
);

export const sharingIsFetchingSelector = createSelector(
  selector,
  store => ({ isFetching: store.isFetching }),
);
